<template>
    <modal titulo="Adicionar Anexo" largura="500" :exibir="exibirModal" @fecharModal="fecharModal">
        <template v-slot:conteudo>
            <v-container class="white" v-if="exibirModal">
                <v-form class="az-form-content d-flex flex-column" lazy-validation ref="form" @submit.prevent>
                    <v-text-field
                        v-model="documento.titulo"
                        name="titulo"
                        v-validate="'required|max:50'"
                        maxlength="50"
                        :counter="50"
                        class="mb-3 mt-1"
                        placeholder="Informe o título do anexo"
                        :error-messages="errors.collect('titulo')"
                    >
                        <template v-slot:label>
                            <label class="estilo-label">
                                Título Anexo
                                <span class="ml-1 red--text">*</span>
                            </label>
                        </template>
                    </v-text-field>

                    <v-select
                        v-model="documento.tipoDocumentoId"
                        name="tipoDocumentoId"
                        class="mb-3"
                        v-validate="'required'"
                        :items="tiposDocumento"
                        item-text="descricao"
                        item-value="id"
                        placeholder="Informe o tipo do anexo"
                        :error-messages="errors.collect('tipoDocumentoId')"
                    >
                        <template v-slot:label>
                            <label class="estilo-label">
                                Tipo Anexo
                                <span class="ml-1 red--text">*</span>
                            </label>
                        </template>
                    </v-select>

                    <campo-arquivo-drag-and-drop
                        v-if="documento.arquivo == null"
                        ref="campoArquivoDragAndDrop"
                        :extensoes-permitidas="extensoesPermitidasArquivo"
                        :mensagemPadraoTooltip="mensagemPadraoTooltip"
                        obrigatorio
                        @files="tratarSetarArquivo"
                    />

                    <v-text-field
                        v-else
                        class="campoUriAnexo mt-6"
                        outlined
                        readonly
                        :value="documento.arquivo.name"
                    >
                        <template v-slot:label>
                            Arquivo
                            <span class="ml-1 red--text">*</span>
                        </template>

                        <template v-slot:append>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <a v-on="on"
                                       slot="activator"
                                       v-on:click="tratarSetarArquivo(null)"
                                       target="_blank"
                                       class="az-action-link-icon mt-1 botaoRemover"
                                    >
                                        <i v-if="temPermissaoEdicao" class="fas fa-times-circle"></i>
                                    </a>
                                </template>
                                Remover
                            </v-tooltip>
                        </template>
                    </v-text-field>
                </v-form>
            </v-container>
        </template>

        <template v-slot:acoes>
            <acoes-formulario>
                <template v-slot:esquerdo>
                    <v-btn color="grey" text outlined width="150"
                        class="text-body-2" @click="fecharModal">
                        Cancelar
                    </v-btn>
                </template>

                <template v-slot:direito>
                    <v-btn
                        depressed
                        width="150"
                        class="text-body-2"
                        color="primary"
                        @click="submit"
                        :disabled="loading"
                        :loading="loading"
                    >
                        Salvar
                    </v-btn>
                </template>
            </acoes-formulario>
        </template>
    </modal>
</template>

<script>
    import Modal from '@/views/components/modal/Modal'
    import AcoesFormulario from '@/views/components/acoes/AcoesFormulario'
    import CampoArquivoDragAndDrop from '@/views/components/campos/editavel/CampoArquivoDragAndDrop.vue'
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/core/constants'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import {isUndefined} from 'lodash'

    const documentoVazio = {
        titulo: '',
        tipoDocumentoId: '',
        arquivo: null,
    }

    export default {
        name: 'ModalFormDocumento',

        components: { AcoesFormulario, Modal, CampoArquivoDragAndDrop},

        emits: ['salvarDados'],

        data: () => ({
            exibirModal: false,
            loading: false,
            tiposDocumento: [],
            nomeTelaRotulos: 'DOCUMENTOS',
            documento: {...documentoVazio},
        }),

        computed: {
            extensoesPermitidas() {
                if (this.$store.state.parametros.extensoesVirtualizacao) {
                    return this.$store.state.parametros.extensoesVirtualizacao.toLowerCase()
                }
                return ''
            },
            temExtensoesPermitidas() {
                return Boolean(this.extensoesPermitidas)
            },
            extensoesPermitidasFormatadas() {
                if (!this.temExtensoesPermitidas) return ''

                return this.extensoesPermitidas.replace(/,\./g, ', .')
            },
            extensoesPermitidasArquivo() {
                if (!this.temExtensoesPermitidas) return []

                return this.extensoesPermitidas.split(',')
            },
            mensagemPadraoTooltip() {
                return `Você só pode adcionar 1 arquivo com as extensões: ${this.extensoesPermitidasFormatadas}`
            },
            temPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            },
        },

        methods: {
            ...mapActions({
                buscarTiposDocumento: actionTypes.DOCUMENTO.BUSCAR_TIPOS_DOCUMENTO,
            }),
            async abrirModal() {
                this.limparForm()
                await this.buscarTipoDocumentos()
                this.exibirModal = true
            },
            fecharModal () {
                this.limparForm()
                this.exibirModal = false
                this.loading = false
            },
            limparForm() {
                this.documento = { ...documentoVazio }
                if (!isUndefined(this.$refs.campoArquivoDragAndDrop)) this.$refs.campoArquivoDragAndDrop.resetValidacao()
                this.$validator._base.reset()
            },
            async validarDadosFormulario() {
                const validaAnexo = (!isUndefined(this.$refs.campoArquivoDragAndDrop)) ? this.$refs.campoArquivoDragAndDrop.validarEnvioObrigatorio() : true
                return await this.$validator._base.validateAll() && validaAnexo
            },
            async submit() {
                if (this.loading) return
                if (!await this.validarDadosFormulario()) return

                this.loading = true
                const documento = this.retiraEspacosVazios(this.documento)
                await this.$emit('salvarDados', documento)
            },
            retiraEspacosVazios(documento) {
                if (documento.titulo) {
                    documento.titulo = documento.titulo.trim()
                }
                return documento
            },
            tratarSetarArquivo(arquivo) {
                this.documento.arquivo = arquivo
            },
            async buscarTipoDocumentos() {
                this.tiposDocumento = await this.buscarTiposDocumento()
            },
        }
    }
</script>

<style lang="stylus" scoped>
.campoValor >>> .v-input__control label
    left -20px !important
</style>
